import { useEffect, useMemo, useState } from 'react';

import useGetPushResults from '@src/hooks/queries/push/useGetPushResults';
import { Modal, Table } from 'antd';
import type { ColumnsType } from 'antd/lib/table';
import { useDispatch } from 'react-redux';

import { closeModal } from '@reduce/modals';

import type { PushResult } from '@type/push';

import type * as T from './type';

const PAGE_SIZE: number = 10;

function FaildPushListModal({ pushId, ...props }: T.FailedPushListModalProps) {
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState<string | undefined>();
  const [page, setPage] = useState<number>(1);

  const {
    data: pushResults,
    total,
    isLoading,
  } = useGetPushResults({ page, q: searchValue, limit: PAGE_SIZE, notificationId: pushId });

  const dataSource: T.FailedPushListDataSource = useMemo(() => {
    if (!pushResults) return [];

    const failList = pushResults.filter(
      ({ status }) => status === 'error' || status === 'rejected',
    );

    return failList.map(v => ({ ...v, key: v.id }));
  }, [pushResults]);

  const columns: ColumnsType<PushResult> = [
    {
      title: '아이디',
      dataIndex: 'id',
      width: '15%',
      render: id => id,
    },
    {
      key: 'name',
      title: '이름',
      dataIndex: 'groupMember',
      width: '15%',
      render: groupMember => {
        return <>{groupMember?.user?.name || ''}</>;
      },
    },
    {
      key: 'phone',
      title: '휴대폰',
      dataIndex: 'groupMember',
      width: '15%',
      render: groupMember => {
        return <>{groupMember?.user?.phone || ''}</>;
      },
    },
    {
      title: '실패사유',
      dataIndex: 'failure',
      width: '40%',
      render: failure => {
        return failure?.error ? JSON.stringify(failure.error) : '-';
      },
    },
  ];

  const close = () => dispatch(closeModal('failedPushList'));

  return (
    <Modal
      {...props}
      open={true}
      title='발송 실패 정보'
      footer={null}
      width='1200px'
      onCancel={close}>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        sticky={true}
        scroll={{ y: 450 }}
        pagination={{
          total,
          current: page,
          pageSize: PAGE_SIZE,
          position: ['bottomCenter'],
          showSizeChanger: false,
          onChange: setPage,
        }}
      />
    </Modal>
  );
}

export default FaildPushListModal;
